// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__POQWR","obliqueLineWrap":"membershipbadge_obliqueLineWrap__14vzG","obliqueLine":"membershipbadge_obliqueLine__gLcGY"};